import { required, numeric, integer, minValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    item: {
      inventory_id: {
        required: helpers.withMessage(i18n.global.t('Please select an ingredient.'), required)
      },
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a name.'), required)
      },
      unit_id: {
        required: helpers.withMessage(i18n.global.t('Please select a unit.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      inventory_unit_id: {
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      ordered_quantity: {
        required: helpers.withMessage(i18n.global.t('Please enter a quantity.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity.'), numeric),
        minValue: helpers.withMessage(i18n.global.t('Quantity must be greater than 0.'), minValue(0.000001))
      },
      conversion_factor: {
        required: helpers.withMessage(i18n.global.t('Please enter a conversion factor.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the conversion factor.'), numeric)
      },
      price_before_vat: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      price_vat: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      price: {
        required: helpers.withMessage(i18n.global.t('Please enter a price.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the price.'), numeric),
        minValue: helpers.withMessage(i18n.global.t('Value must be greater than 0.'), minValue(0.000001))
      },
      discount_before_vat: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      discount_vat: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      discount: {
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric),
        minValue: helpers.withMessage(i18n.global.t('Value must be greater than 0.'), minValue(0.000001))
      },
      prorated_order_discount_before_vat: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      prorated_order_discount_vat: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      prorated_order_discount: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      prorated_shipping_cost_before_vat: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      prorated_shipping_cost_vat: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      prorated_shipping_cost: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      total_before_vat: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      total_vat: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      total: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric),
        minValue: helpers.withMessage(i18n.global.t('Value must be greater than 0.'), minValue(0.000001))
      },
      expiry_date: {
      },
      tax_status: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      }
    }
  }
};
